import React, { useMemo } from 'react';
import _ from 'lodash';
import '@patternfly/react-core/dist/styles/base.css';
import useAPI from '../../../services/useAPI';
import LinkResource from './LinkResource';
import { SortDirection } from '../../Common/SimpleTable/SimpleTable';
import { NodeType } from '../../../utils/types';
import { useQuery } from '@tanstack/react-query';
import createQueryRequest from 'services/createQueryRequest';
import { assetKeys } from '../Assets/queries';

const columns = [
  {
    label: '',
    path: 'displayName',
    isSortable: true,
    searchItem: true
  },
  {
    label: '',
    path: 'modelId',
    isSortable: true,
    searchItem: true
  }
];

const createAssetEdges = (assets, parentId) => {
  return assets.map((asset) => {
    return {
      fromId: parentId,
      fromType: 'node',
      toType: 'asset',
      toId: asset.id,
      relation: 'CONTAINS'
    };
  });
};

const DefaultSortBy = {
  path: 'displayName',
  direction: SortDirection.DESC
};

const LinkAsset = ({ parentItem, onLinkAssets, disableLink, isLinking }) => {
  const api = useAPI();

  const assetQuery = useQuery({
    queryKey: assetKeys.assets(),
    queryFn: createQueryRequest(api.core.getAssets)
  });

  const assets = useMemo(() => {
    if (!assetQuery.data) {
      return [];
    }
    if (!parentItem?.children) {
      return assetQuery.data;
    }
    return assetQuery.data.filter((asset) => {
      return !parentItem?.children.some((child) => {
        return child.id === asset.id;
      });
    });
  }, [assetQuery.data, parentItem?.children]);

  const _onLinkAssets = (selectedResources) => {
    const edges = createAssetEdges(selectedResources, parentItem.id);
    // FIXME: this is a hack to get around the fact that the API doesn't support linking multiple assets at once
    onLinkAssets(_.first(edges));
  };

  return (
    <>
      <LinkResource
        parentItem={parentItem}
        onLinkResources={_onLinkAssets}
        data={assets}
        isLoading={assetQuery.isLoading}
        isLinking={isLinking}
        columns={columns}
        defaultSortBy={DefaultSortBy}
        disableLink={disableLink || parentItem.type !== NodeType.Node}
      />
    </>
  );
};

export default LinkAsset;
